<script setup lang="ts">
import NavBar from '@/layouts/nav-bar/NavBar.vue'
import { RouterView, useRoute } from 'vue-router'
import SideBar from '@/layouts/side-bar/SideBar.vue'
import { useWorkspaceStore } from '@/stores/workspaces'
import { storeToRefs } from 'pinia'

const route = useRoute();
const workspaceId = route.params.id;

const workspaceStore = useWorkspaceStore()
const { selected } = storeToRefs(workspaceStore)
</script>

<template>
  <v-app class="fill-height d-flex">
    <SideBar v-if="workspaceId" />
    <v-main>
      <div
        class="app-content-container boxed-container pa-0 fill-height bg-surface-secondary flex-fill"
      >
        <NavBar :has-logo="!workspaceId" />
        <RouterView :key="selected" />
      </div>
    </v-main>
  </v-app>
</template>
